import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { OpportunityBoardType, Status } from '@fitness-force/enum';
import { NotFoundError } from '@fitness-force/models';;
import type { ListOpportunityStageMasterResponse, OpportunityStageMasterResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { AppErrors } from '@fitness-force/models';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OpportunityStageService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  //tenants/{tenant_id:int}/boards/{board_id:int}/opportunities
  OpportunityStageMasterListService(tenantId: number, boardType: OpportunityBoardType): Observable<ListOpportunityStageMasterResponse> {

    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITYSTAGEMASTER.GET_OPPORTUNITY_STAGE_MASTERS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{board_type}', boardType.toString()), this.httpOptions)
      .pipe(
        map((res: any) => {
          //filter has to be revoved when stage master is created
          res.items = res.items.filter((oppStageMaster: OpportunityStageMasterResponse) => oppStageMaster.status === Status.Active || oppStageMaster.status.toString() === Status[Status.Active]);
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getOpportunityStageMaster(tenantId: number, boardType: OpportunityBoardType,opp_stage_mst_id:number): Observable<ListOpportunityStageMasterResponse> {
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.OPPORTUNITYSTAGEMASTER.GET_OPPORTUNITY_STAGE_MASTER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{board_type}', boardType.toString())
      .replace('{stage_id}', opp_stage_mst_id.toString()), this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
